import Manager from 'coreClasses/Manager';

export type TTemplateVariables = Record<string, string | number | boolean | undefined | null>;

/**
 * Manages the template variables by fetching data from various managers.
 */
class StringTemplateVariablesMgr extends Manager {
	/**
	 * Gets the current language.
	 *
	 * @returns {string} The current language code.
	 */
	private getCurrentLanguage(): string {
		return this.managerRepository.getLocalesMgr().getCurrentLanguage()?.getLanguageCode() || '';
	}

	/**
	 * Gets the current country.
	 *
	 * @returns {string} The current country code.
	 */
	private getCurrentCountry(): string {
		return this.managerRepository.getLocalesMgr().getCurrentCountry()?.getCountryCode() || '';
	}

	/**
	 * Retrieves all template variables.
	 *
	 * @returns {TTemplateVariables} An object containing all template variables.
	 */
	public getVariables(): TTemplateVariables {
		return {
			currentLanguage: this.getCurrentLanguage(),
			currentCountry: this.getCurrentCountry(),
		};
	}
}

export default StringTemplateVariablesMgr;
